module.exports = __webpack_public_path__ + "img/home-duckrabbit_xl.a2051c7e.png";